import { Dispatch, SetStateAction } from "react";

import { MultiSelectOption } from "./IMultiSelectOption";

/**
 * A utility function for when you want to treat MultiSelects as a nullable single
 * item selector without repeating the same array logic.
 *
 * Intended for use with getSingleSelectedItemAsArray()
 *
 * Allows you to useState<MultiSelectOption>() instead of
 * useState<MultiSelectOption[]>()
 *
 * Example use:
 *
 * const [thing, setSelectedThing] = useState<MultiSelectOption | null>(null);
 *
 * <Multiselect
 *   {...snippedProps}
 *   maxSelections={1} //Not required to limit to 1, but intended
 *   selectedItems={getSingleSelectedItemAsArray(thing)}
 *   setSelectedItems={getOnSingleSelectionChange(setSelectedThing, thing)}
 * />
 *
 */

export function getOnSingleSelectionChange<T extends MultiSelectOption>(
  setSelectedItem: Dispatch<SetStateAction<T | null>>,
  currentItem: T | null
) {
  // Returns undefined if nothing is selected
  return (selectedItem: T) =>
    selectedItem.id === currentItem?.id
      ? setSelectedItem(null)
      : setSelectedItem(selectedItem);
}
